import { useAuth } from 'react-oidc-context';

export function useOidcConfig() {
  const { settings } = useAuth();
  return settings;
}
